/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';


type Props = {
  src: string;
  height: number;
};

const styles = {
  logo: (height: number) => css`
    object-fit: contain;
    width: auto;
    max-width: 240px;
    height: ${height}px;
  `,
};

function ContentfulLogo({ src, height }: Props) {
  return <img src={src} css={styles.logo(height)} alt="Coursera logo" />;
}

export default ContentfulLogo;
